import { useState, useCallback, useEffect } from 'react';
import axios from '../utils/axios';
import { useToast } from "@/components/ui/use-toast";

const getValidationRules = (stepKey, actionType) => {
    if (stepKey === 'configuration') {
        switch (actionType) {
            case 'ping':
                return [
                    { field: 'organizationId', required: true },
                    { field: 'hostname', required: true, regex: /^[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+[/#?]?.*$/ }
                ];
            case 'browser_agent':
                return [
                    { field: 'organizationId', required: true },
                    { field: 'url', required: true, regex: /^https?:\/\/.+/ },
                    { field: 'prompt', required: true }
                ];
            default:
                return [
                    { field: 'organizationId', required: true }
                ];
        }
    }
    return null;
};

export const useStepData = (initialSteps, monitorId = null) => {
    const [steps, setSteps] = useState(initialSteps);
    const [isAutoSaving, setIsAutoSaving] = useState(false);
    const { toast } = useToast();

    const updateStepData = useCallback(async (stepKey, data) => {
        setSteps(prevSteps => {
            const actionType = prevSteps.find(step => step.key === 'actionType')?.data;
            const validationRules = getValidationRules(stepKey, actionType);
            
            return prevSteps.map(step => {
                if (step.key === stepKey) {
                    const isComplete = validationRules ? validationRules.every(({ field, required, regex }) => {
                        const value = typeof data === 'object' ? data[field] : data;
                        if (required && (value === undefined || value === '')) {
                            return false;
                        }
                        if (regex && !regex.test(value)) {
                            return false;
                        }
                        return true;
                    }) : step.validation.every(({ field, required, regex }) => {
                        const value = typeof data === 'object' ? data[field] : data;
                        if (required && (value === undefined || value === '')) {
                            return false;
                        }
                        if (regex && !regex.test(value)) {
                            return false;
                        }
                        return true;
                    });
                    return { ...step, data, isComplete };
                }
                return step;
            });
        });
    }, [monitorId, steps]);

    const getStepData = useCallback((stepKey) => {
        return steps.find(step => step.key === stepKey)?.data || {};
    }, [steps]);

    const isStepComplete = useCallback((stepKey) => {
        return steps.find(step => step.key === stepKey)?.isComplete || false;
    }, [steps]);

    return {
        steps,
        updateStepData,
        getStepData,
        isStepComplete,
        isAutoSaving
    };
};
